import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { ChatLink } from "tsi-common-react/src/apps/chat/ChatLink";
import { useAppSelector } from "tsi-common-react/src/apps/reducers";
import { RichText } from "tsi-common-react/src/common/RichText";
import { strToBool } from "tsi-common-react/src/utils/format";
import { getPageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import iconSpeechBubblesTalk from "../../svg/speech-bubbles-talk.svg";

interface IProps {}

export const CheckoutSidebarContent = (_props: IProps) => {
    const basketId = useAppSelector(
        (state) => state.checkout.data.basket?.encoded_basket_id,
    );
    const contactURL = usePageURL("contact-us-form");
    const homeURL = usePageURL("home");
    let questionsBlock: JSX.Element | null = null;

    if (strToBool(getPageSetting("enable-checkout-sidebar-questions-block"))) {
        questionsBlock = (
            <div className="basket-summary__help">
                <h3>
                    <SVG
                        className="basket-summary__help-icon"
                        src={iconSpeechBubblesTalk}
                        title={t`Speech Bubbles Icon`}
                    />
                    {t`Questions?`}
                </h3>
                <div className="basket-summary__text">
                    <ChatLink
                        className="basket-summary__help--link"
                        chatOfflineLink={contactURL || homeURL}
                    />
                    {/* TODO(i18n): Use jt to keep complete sentence together with interpolated components: jt`or ${callStrong} and reference ${basketIdStrong}` where callStrong and basketIdStrong are the <strong> elements */}
                    <span>
                        {" "}
                        or{" "}
                        <strong>
                            Call{" "}
                            {getPageSetting("pre-order-phone-number-display")}
                        </strong>{" "}
                        and reference <strong>{basketId}</strong>
                    </span>
                    <br />
                </div>
            </div>
        );
    }
    return (
        <div className="basket-summary__sidebar-content">
            {questionsBlock}
            <RichText html={getPageSetting("checkout-sidebar-extra-content")} />
        </div>
    );
};
